module.exports = __webpack_public_path__ + "img/gzh-img.1473bc80.png";